module.exports = __webpack_public_path__ + "img/YL.f4617f5d.png";